<div class="app-container {{ mode() }}">
   
  <app-spinner></app-spinner>

  <app-header (toggleMenu)="toggleMobileSideMenu()" (modeToggle)="toggleMode()" [mode]="mode()"></app-header>

  <div class="side-menu-and-main">
    <app-side-menu (toggleMenu)="toggleMobileSideMenu()" [mobileNavOpen]="mobileNavOpen()" (modeToggle)="toggleMode()" [mode]="mode()"></app-side-menu>
    <main>
        
      <div class = "main-container">
        <router-outlet></router-outlet>
      </div>

      <app-footer></app-footer>
              
    </main>
  </div>

</div>